import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
type ContactFormProps = {
  open: boolean;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onClose: () => void;
};

const ContactFormModal: React.FC<ContactFormProps> = ({ open, onSubmit, onClose }) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle
        style={{
          fontFamily: "Poppins !important",
          color: "#525252",
          marginBottom: -25,
        }}
      >
        {t("Contact Us")}
      </DialogTitle>
      <hr />
      <DialogContent>
        <form id="contact-form" onSubmit={onSubmit}>
          <div className="form-group">
            <label htmlFor="subject" className="form-label">
              {t("Subject")}
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              className="form-control"
              required
              title=""
              onInvalid={(e) => {
                e.currentTarget.setCustomValidity(`${t("This field is required")}`);
              }}
              onInput={(e) => {
                e.currentTarget.setCustomValidity(``);
              }}
            />
          </div>
          <div className="form-group">
            <label htmlFor="message" className="form-label">
              {t("Message")}
            </label>
            <textarea
              id="message"
              name="message"
              rows={3}
              className="form-control"
              required
              title=""
              onInvalid={(e) => {
                e.currentTarget.setCustomValidity(`${t("This field is required")}`);
              }}
              onInput={(e) => {
                e.currentTarget.setCustomValidity(``);
              }}
            />
          </div>
        </form>
        <DialogActions style={{ marginTop: 15 }}>
          <Button
            variant="contained"
            style={{
              backgroundColor: "#000000",
              color: "#ffffff",
              textTransform: "capitalize",
            }}
            onClick={() => onClose()}
          >
            {t("Cancel")}
          </Button>
          <Button
            type="submit"
            form="contact-form"
            color="primary"
            variant="contained"
            style={{
              backgroundColor: "var(--text-primary)",
              textTransform: "capitalize",
            }}
          >
            {t("Send")}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ContactFormModal;
